import {
  GhostIconButton,
  Modal,
  ModalTrigger,
  PrimaryButton,
} from "@certn/cascadia-react";
import { NavigationBar } from "@certn/cascadia-react/components/navigation/navigation-top/NavigationBar";
import { css } from "@emotion/css";
import { FormikErrors } from "formik";
import { FormEvent, useState } from "react";
import { Trans } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import { CancelModal } from "./modals/CancelModal";
import { NoQuestionsModal } from "./modals/NoQuestionsModal";
import { SaveModal } from "./modals/SaveModal";
import { Schemas } from "../../../types";
interface Props {
  templateType: Schemas["TemplateTypeEnum"];
  isValid: boolean;
  handleSubmit?: (e?: FormEvent<HTMLFormElement> | undefined) => void;
  validateForm?: (
    values?: any
  ) => Promise<FormikErrors<any> | FormikErrors<any> | undefined>;
}

export function TemplateNavigation(props: Props) {
  const { isValid, handleSubmit, validateForm, templateType } = props;
  const { id } = useParams();
  const navigate = useNavigate();
  const [showSaveModal, setShowSaveModal] = useState(false);
  const [showNoQuestionsModal, setShowNoQuestionsModal] = useState(false);

  const backUrl =
    templateType === "CUSTOM"
      ? "/settings/custom-questionnaire-templates"
      : "/settings/questionnaire-templates";

  return (
    <NavigationBar testID="questionnaire-templates-navbar">
      <div className={styles.stack}>
        {id && (
          <GhostIconButton
            testID="open-cancel-modal"
            icon="close"
            size="medium"
            onPress={() => navigate(backUrl)}
          />
        )}
        {!id && (
          <ModalTrigger
            trigger={() => (
              <GhostIconButton
                testID="open-cancel-modal"
                icon="close"
                size="medium"
              />
            )}
          >
            <Modal>
              <CancelModal />
            </Modal>
          </ModalTrigger>
        )}
        {validateForm && (
          <PrimaryButton
            testID="save-new-questionnaire-template"
            isDisabled={!isValid}
            onPress={async () => {
              const errors = await validateForm();
              setShowSaveModal(
                errors === undefined || Object.keys(errors).length === 0
              );
              setShowNoQuestionsModal(
                !!errors && Object.keys(errors).length > 0
              );
            }}
          >
            <Trans>Save template</Trans>
          </PrimaryButton>
        )}
        {handleSubmit && showSaveModal && (
          <SaveModal
            onClose={() => setShowSaveModal(false)}
            show={showSaveModal}
            handleSubmit={handleSubmit}
          />
        )}
        {showNoQuestionsModal && (
          <NoQuestionsModal
            onClose={() => setShowNoQuestionsModal(false)}
            show={showNoQuestionsModal}
          />
        )}
      </div>
    </NavigationBar>
  );
}

const styles = {
  stack: css({
    display: "flex",
    justifyContent: "space-between",
  }),
};
